
























//@ts-ignore
import store from "../../store";
import {Component, Vue} from "vue-property-decorator";
import {AutomationPlayerMap, CurrentGame, GameAutomation, GameSettings, Player, PlayerSymbols} from "../../../types";
import EventApi from "../../api/EventsApi";

@Component({
    props: {
        player: {
            required: true,
            type: Object
        }
    }
})

export default class PlayerSymbol extends Vue{
    private isOpen: boolean = false;
    private selected: string|null = null;
    private isInverted: boolean = false;
    private player!: Player;
    private symbols: PlayerSymbols = {
        icons: {
            items: [
                // 'ic_empty',
                'ic_flag',
                // 'ic_lightning',
                'ic_heart',
                'ic_star'
            ],
            type: 'icons'
        },
        digits: {
            items: [],
            type: 'digits'
        },
        digitsInverted: {
            items: [],
            type: 'inverted'
        },
    };


    mounted(): void
    {
        const playersCount: number = PlayerSymbol.getPlayersCount();

        this.symbols.digits.items = PlayerSymbol.getAvailableDigits(playersCount);
        this.symbols.digitsInverted.items = PlayerSymbol.getAvailableDigitsInverted(playersCount);
    }

    /**
     * Текущая игра
     */
    private get currentActivity(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Настройки текущей игры
     */
    private get currentActivitySettings(): GameSettings|null
    {
        if (!this.currentActivity) {
            return null;
        }
        return this.currentActivity.settings;
    }

    /**
     * Видны ли иконки игроков
     */
    private get playerSymbolIsVisible(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canViewPlayerIcons;
    }

    /**
     * Можно ли управлять иконками игроков
     */
    private get playerSymbolsAreManageable(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canManagePlayerIcons;
    }

    /**
     * Данные игрока
     */
    private get playerData():any
    {

        if (typeof store.getters.getGameState.playersData === "undefined") {
            return null;
        }

        let playersData = store.getters.getGameState.playersData;

        if (typeof playersData[this.player.id] === "undefined") {
            return null;
        }

        return playersData[this.player.id];
    }

    /**
     * Иконка игрока
     */
    private get playerIcon(): string
    {
        let playerData = this.playerData;

        if (!playerData || !playerData.icon) {
            return '';
        }

        if (playerData.icon.indexOf('inverted') === -1) {
            this.isInverted = false;
        } else {
            this.isInverted = true;
        }

        return '#' + playerData.icon;
    }

    /**
     * Доступные цифры для нумерации игроков
     */
    private static getAvailableDigits(count: number = 0): Array<string>
    {
        const digits: Array<string> = [];
        for(let i = 0; i < count; i++) {
            digits.push(`ic_digit_${i+1}`);
        }

        return digits;
    }


    /**
     * Доступные инвертированные цифры для нумерации игроков
     */
    private static getAvailableDigitsInverted(count: number = 0): Array<string>
    {
        const digits: Array<string> = [];
        for(let i = 0; i < count; i++) {
            digits.push(`ic_digit_inverted_${i+1}`);
        }

        return digits;
    }


    /**
     * Количество игроков (не гостей)
     */
    private static getPlayersCount(): number
    {
        return store.getters.getPlayers.filter((player: any) => player.connectionStatus === 'active').length;
    }

    /**
     * Открыть/закрыть список символов
     */
    private toggleOpen(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        if (!this.playerSymbolsAreManageable) {
            return;
        }

        if (this.isOpen && this.playerIcon) {
            this.selected = null;
            this.$emit('changeIcon', this.selected);
        }

        this.isOpen = !this.isOpen;
    }

    /**
     * Выбрать символ
     * @param {string} symbol - идентификатор выбранного символа
     * @param {string} type - тип иконки
     */
    private selectSymbol(symbol: string, type: string): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        if (symbol !== 'ic_empty') {
            this.selected = symbol;
        } else {
            this.selected = null;
        }

        if (type === 'inverted') {
            this.isInverted = true;
        } else {
            this.isInverted = false;
        }

        this.isOpen = false;

        this.$emit('changeIcon', this.selected);
    }
}
